export enum SystemNamesEnum {
  ANGULAR_FRONTEND = 'ANGULAR_FRONTEND',
  DELIVERY = 'DELIVERY',
}
